import * as actions from './actionTypes'

export const cookiedEnabledAction = (flag) => ({
  type: actions.COOKIES_ENABLED,
  payload: {
    description: flag,
  },
})

export const screenLoadingAction = () => ({
  type: actions.SCREEN_LOADING,
})

export const changeObjectPropertyAction = (object, field, value) => ({
  type: actions.CHANGE_OBJECT_PROPERTY,
  payload: {
    object,
    field,
    value
  }
})

export const setPayDebtOnBehalf = (value) => ({
  type: actions.SET_PAY_DEBT_ON_BEHALF,
  payload: value
})


export const setEditDebtInfo = (value) => ({
  type: actions.EDIT_DEBT_INFO,
  payload: {
    value
  }
})


export const listAddAction = (listType, data) => ({
  type: actions.LIST_ADD,
  payload: {
    listType,
    data
  }
})

export const listEditAction = (listType, data) => ({
  type: actions.LIST_EDIT,
  payload: {
    listType,
    data
  }
})


export const listDeleteAction = (listType, data) => ({
  type: actions.LIST_DELETE,
  payload: {
    listType,
    data
  }
})

export const clearListInfoAction = (listType) => ({
  type: actions.LIST_CLEAR,
  payload: {
    listType
  }
})

export const clearLastDebtAction = () => ({
  type: actions.CLEAR_LAST_DEBT
})

export const clearDebtAction = () => ({
  type: actions.CLEAR_DEBT_INFO
})

export const clearAllAction = () => ({
  type: actions.CLEAR_ALL,
})

export const clearAppDataAction = () => ({
  type: actions.CLEAR_APP_DATA
})

